import React, { useState } from "react";
// import closepopup from "../../assets/Dashboard/Group 442.svg";
// import images from "../../assets/Dashboard/Union (4).svg";
import Attachment from "../../../../Assets/AppComponent/attachment copy.svg";
import closepopup from "../../../../Assets/AppComponent/Group 442 (1).svg";

const FileAttachementPopup = (props) => {
  const { setFilePopup, filePopup, Attchment } = props;

  const fileNames = Attchment.map((url) => url.split("/").pop());
  const handleClick = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div>
      <div className="overlay">
        <div className="popups">
          <div className="popupHeader">
            <div></div>

            <span className="TitleHeader">Attachments</span>
            <img
              src={closepopup}
              style={{ cursor: "pointer" }}
              onClick={() => {
                setFilePopup(false);
              }}
            />
          </div>
          <div style={{
    display: "grid",
    gap: "10%",
    height: "300px",
    overflowY: "auto",
    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
  }}
>
            {Attchment.map((url, index) => (
              <div key={index} onClick={() => handleClick(url)}>
                <span
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={Attachment}
                    style={{ width: "40px", height: "50px" }}
                  />
                  <span style={{ textTransform: "capitalize" }}>
                    {fileNames[index]?.length > 6
                      ? `${fileNames[index].slice(0, 6)}...`
                      : fileNames[index]}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileAttachementPopup;
